import React from "react";
import "./Start.css";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useBaseUrl } from "../../ApiContext";

export default function Start() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl();
  const location = useLocation();
  const { userToken } = useAuth();
  const { goal, activity, age, height, weight } = location.state || {};

  const handleStartBtn = async () => {
    try {
      const postData = {
        height: height,
        weight: weight,
        age: age,
        physical_activity: activity,
        goal: goal,
      };
      const response = await Axios.post(`${baseUrl}/profile_info`, postData, {
        headers: {
          Authorization: `Token ${userToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = response.data;
      if (data) {
        navigate("/home");
      }
    } catch (error) {
      console.error("Error during the POST request:", error);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageHeader centeredFlex">
          <BackBtn />
        </div>
        <div className="start">
          <div className="startWrapper">
            <div>
              <h3 className="startHeading">ممنونم</h3>
              <h4 className="startText">
                پس از انتخاب گزینه شروع اطلاعات شما در اپلیکیشن هماهنگ سازی
                خواهد شد!
              </h4>
            </div>
            <button className="nextQuestion" onClick={handleStartBtn}>
              شروع
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
